module.exports = __webpack_public_path__ + "img/arrow.1d15ff16.svg";